export default function Footer() {
  return (
    <footer className="bg-background-200 border-t border-background-300/60">
      <div className="px-6 md:px-10 py-6 md:py-8 lg:py-5">
        <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-6 lg:gap-8">
          {/* Logo */}
          <a href="#hero" className="inline-block mx-auto lg:mx-0">
            <img
              src="https://storage.readdy-site.link/project_files/732df27f-b232-4dc5-8c9d-bb28540a6b17/c5d5e167-a148-4f5d-90c8-cbf6e11734b1_compressed_Logonombre-sf.webp"
              alt="GOU Abogados"
              className="h-36 md:h-44 lg:h-32 w-auto object-contain"
            />
          </a>

          {/* Datos de contacto */}
          <div className="text-left lg:text-right">
            <p className="font-heading text-base md:text-lg font-bold text-accent-600 mb-2">Contacto</p>
            <a
              href="https://maps.app.goo.gl/fn7SEcALB6SrMbzm8"
              target="_blank"
              rel="noopener noreferrer"
              className="block text-sm text-foreground-700 mb-1 hover:text-primary-500 transition-colors cursor-pointer"
            >
              Jujuy 76 Oficina 3ª, Córdoba
            </a>
            <a
              href="tel:+543513495570"
              className="block text-sm text-foreground-700 mb-1 hover:text-primary-500 transition-colors cursor-pointer"
            >
              +54 351-3495570
            </a>
            <a
              href="mailto:gou-abogados@hotmail.com"
              className="block text-sm text-foreground-700 hover:text-primary-500 transition-colors cursor-pointer"
            >
              gou-abogados@hotmail.com
            </a>
          </div>
        </div>
      </div>

      {/* Copyright - full width, centered, with edge-to-edge line below */}
      <div className="pt-4">
        <p className="text-xs text-foreground-500 text-center">
          &copy; {new Date().getFullYear()} GOU Abogados
        </p>
        <div className="mt-3 border-b border-background-300/60 w-full" />
      </div>
    </footer>
  );
}